import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Routes, Route } from "react-router-dom";

import Main from "./globalVar/main"
import Add from "./globalVar/add"
import Edit from "./globalVar/edit"

function Var() {
    const navigate = useNavigate()
    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/login")
        }
    }, [navigate])


    return (
        <>
            <Routes>
                <Route path="/" element={<Main />} />
                <Route path="/add" element={<Add />} />
                <Route path="/edit/*" element={<Edit />} />
            </Routes>
        </>
    );
}

export default Var;
